"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiQuickStopIndicator = void 0;
var _pixiGame = require("@dragon/pixi-game");
var _pixi = require("pixi.js");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Quick Stop Indicator, create visual and/or audio indication of quick stop/slam stop.
 * Can also be used to indicate skip win Presentation.
 * Usually a flash of light across the game or just real frame.
 * a feedback on a user action.
 */
var PixiQuickStopIndicator = exports.PixiQuickStopIndicator = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiQuickStopIndicator() {
    var _this;
    _classCallCheck(this, PixiQuickStopIndicator);
    _this = _callSuper(this, PixiQuickStopIndicator, ["QuickStopIndicator"]);
    _defineProperty(_this, "_indicator", void 0);
    var gfx = new _pixi.Graphics();
    gfx.beginFill(0xFFD700);
    gfx.drawRect(0, 0, 400, 400);
    gfx.endFill();
    var maskT = _this.application.renderer.generateTexture(gfx, {
      scaleMode: _pixi.SCALE_MODES.LINEAR,
      resolution: 1
    });
    _this._indicator = new _pixi.Sprite(maskT);
    _this._indicator.name = "QuickStopSprite";
    _this._indicator.alpha = 0;
    _this.addChild(_this._indicator);
    return _this;
  }

  /**
   * show the indicator
   */
  _inherits(PixiQuickStopIndicator, _PixiGameComponent);
  return _createClass(PixiQuickStopIndicator, [{
    key: "show",
    value: function show() {
      _gsap["default"].killTweensOf(this._indicator);
      this._indicator.alpha = 0;
      _gsap["default"].to(this._indicator, {
        duration: 0.125,
        alpha: 0.1,
        yoyo: true,
        repeat: 1
      });
    }
  }, {
    key: "onResize",
    value: function onResize(s) {
      this._indicator.width = s.width;
      this._indicator.height = s.height;
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiQuickStopIndicator.js.map